import { AppState } from 'app/store';

export const getIntercomConfigLink = (state: AppState) =>
  state.auth.services?.intercom?._links.getClientConfiguration;

export const getIntercomConfig = (state: AppState) =>
  state.intercom?.intercomConfig;

export const getIntercomUserHash = (state: AppState) =>
  state.intercom?.userHash;

export const getIntercomLoadingState = (state: AppState) =>
  state.intercom.intercomLoading;
